import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { THEME } from './i18n';

// Apply theme attribute before first render so CSS variables are ready
document.documentElement.dataset.theme = THEME;


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
